var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticimax-menu" },
    _vm._l(Object.keys(_vm.menuGroups), function (groupId) {
      return _c("div", { key: groupId, staticClass: "group-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "group",
            class: {
              collapsed: _vm.isGroupCollapsed(groupId),
              selected: _vm.isGroupSelected(groupId),
            },
            on: {
              click: function ($event) {
                return _vm.toggleGroup(groupId)
              },
            },
          },
          [
            _c("div", { staticClass: "left" }, [
              _c(
                "span",
                { staticClass: "icon" },
                [groupId === "Templates" ? _c("HomeIcon") : _vm._e()],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("ticimax." + groupId))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c(
                  "IconButton",
                  {
                    staticClass: "collapse-button",
                    attrs: {
                      "on-click": function () {
                        return _vm.toggleGroup(groupId)
                      },
                    },
                  },
                  [
                    !_vm.isGroupCollapsed(groupId)
                      ? _c("a-icon", {
                          attrs: { type: "caret-down" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleGroup(groupId)
                            },
                          },
                        })
                      : _c("a-icon", {
                          attrs: { type: "caret-up" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleGroup(groupId)
                            },
                          },
                        }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "list",
            class: { hidden: !_vm.isGroupCollapsed(groupId) },
          },
          _vm._l(
            _vm.menuGroups[groupId].filter(function (x) {
              return !x.disabled
            }),
            function (item) {
              return _c("div", { key: item.id }, [
                _c(
                  "div",
                  {
                    staticClass: "item",
                    class: { selected: _vm.value === item.id },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("input", item.id)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("ticimax." + item.id)) +
                        "\n                "
                    ),
                  ]
                ),
              ])
            }
          ),
          0
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }